import axios from 'axios'

import apiErrorHandler from '@shared/apiErrorHandler'
import responseOkGuard from '@shared/responseOkGuard'

export const createApiClient = (
  hostToEnvMap: Record<string, string>,
  envToUrlMap: Record<string, string>,
  defaultEnv: string,
  urlTemplate: string,
  host?: string,
) => {
  const hostname = host ?? window.location.hostname

  const rawEnv = hostToEnvMap[hostname] || hostname?.split('.')?.[0] || defaultEnv

  const baseURL = envToUrlMap[rawEnv] || urlTemplate.replace('{env}', rawEnv)

  const axiosInstance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  })

  axiosInstance.interceptors.response.use(responseOkGuard, apiErrorHandler, { synchronous: true })

  return axiosInstance
}
